//we use this id for create unic name for multiselect
//only used for the ac selection
var radioUnicId = 0

export function inventory_update(id) {

    radioUnicId++
    return `

    <div class="line line-${id} mt-inventory-update-line" lineId="${id}" id="inventoryUpdate_form_mt_${radioUnicId}"> 

        <div class="btn-item-info" data-detail='{"click": [
            {"dest":"ripple"},
            {"dest":"inventoryUpdate", "elem":"fullcont", "act":"jumperToPurchase", "lineId":"${id}"}
        ]}'></div>

        <div class="textfield textfield-mini textfield-disabled purchase_code mt-inventory-cell">
            <input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
        </div>

        <div class="textfield textfield-mini textfield-disabled provider_name mt-inventory-cell">
            <input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
        </div>

        <div class="textfield textfield-mini textfield-disabled purchase_date mt-inventory-cell">
            <input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
        </div>

        <div class="textfield textfield-mini textfield-disabled item_description mt-inventory-cell">
            <input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
        </div>

        <div class="textfield textfield-mini textfield-disabled unit mt-inventory-cell">
            <input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
        </div>

        <div class="textfield textfield-mini qty mt-inventory-cell">
            <input autocomplete="off" class="elem" type="number" step="1" min="0"
            data-detail='{
                "key": [
                    {"dest":"textfield", "act":"typing"},
                    {"dest":"inventoryUpdate", "elem":"fullcont", "act":"validateQty", "lineId":"${id}"}
                ]
            }' >
        </div>

        <div class="textfield textfield-cash textfield-mini selling_price mt-inventory-cell">
            <input autocomplete="off" class="elem" type="number" step="0.01" min="0"
            data-detail='{
                "key": [
                    {"dest":"textfield", "act":"typing"},
                    {"dest":"inventoryUpdate", "elem":"fullcont", "act":"validateSellingPrice", "lineId":"${id}"}
                ]
            }' >
        </div>

    </div><!-- line -->  
    `
}
